






import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class PersonSelectCard extends Vue {
    @Prop({ default: "" }) name: string;
}
